import React, { Component } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import app from "../../../plugins/routes/app";


import cookie from "js-cookie";
import { connect } from "react-redux";

class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [{ title: "Home", route: "/app/" }]
    };
    this.breadcrumbs = [{ title: "Home", route: "/app/" }];
    this.breadcrumbsReference = window.location.pathname;
  }

  componentWillMount() {
    const token = cookie.get("access_token");
    if (!token) {
      window.location.pathname = "/auth";
      
    }
    this.getBreadcrumbs();
    this.setState({
      breadcrumbs: this.breadcrumbs
    });
  }

  componentWillReceiveProps() {
    this.breadcrumbsReference = window.location.pathname;
    if (
      this.breadcrumbsReference !==
      this.state.breadcrumbs[this.state.breadcrumbs.length - 1].route
    ) {
      this.getBreadcrumbs();
      this.setState({
        breadcrumbs: this.breadcrumbs
      });
    }
  }

  getBreadcrumbs() {
    let currentRoute = "/app";
    let breadcrumbs = [];
    let exceptFor = ["membership", "company", "definitions"];
    let routes = this.breadcrumbsReference.split("/");

    breadcrumbs.push({ title: "home", route: "/app" });
    routes.splice(0, 2);
    if (!isNaN(routes[routes.length - 1])) {
      routes.splice([routes.length - 1], 1);
    }
    routes.forEach((route, index) => {
      currentRoute = currentRoute + "/" + route;
      if (route.replace(route[0], route[0].toLowerCase()) !== "home") {
        breadcrumbs.push({
          title:
            index > 0 &&
              index > routes.length - 2 &&
              exceptFor.includes(routes[0])
              ? routes[index - 1] +
              route.replace(route[0], route[0].toUpperCase())
              : route,
          route: currentRoute
        });
      }
    });
    this.breadcrumbs = breadcrumbs;
  }

  render() {

    return (
      <div className="panel-body">
        {/* <Breadcrumb separator="/">
          {breadcrumbs.map((breadcrumb, index) => (
            <Breadcrumb.Item key={index}>
              {breadcrumb.route === this.breadcrumbsReference ? (
                i18n.t(`${breadcrumb.title}`, {
                  lng: this.props.currentLanguage
                })
              ) : (
                <NavLink to={`${breadcrumb.route}`}>
                  {i18n.t(`${breadcrumb.title}`, {
                    lng: this.props.currentLanguage
                  })}
                </NavLink>
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb> */}

        <Switch>
          {app.routes.map((route, key) => {
            return (
              <Route
                path={`${app.path}${route.path}`}
                component={route.component}
                key={key}
              />
            );
          })}
          <Redirect from="/app" to="/app/trips" />
        </Switch>

      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default withRouter(connect(mapStateToProps)(Content));



// WEBPACK FOOTER //
// ./src/components/App/Layout/Content.js